export const ROLE_ADMIN = 'admin';
export const ROLE_OPERATOR = 'operator';
export const ROLE_MEDIC = 'medic';
